import React, { forwardRef } from "react";
import classNames from "classnames";
import styles from "./PhoneInput.module.scss";

import {
  PhonenumberFields,
  isValidSaudiPhoneNumber,
} from "../../../setup/util/phoneNumber.helpers";
import { validateNumber } from "../../../setup/util/helpers";
import { useTranslation } from "react-i18next";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  errorMessage?: string;
}

const PhoneInput = forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, onBlur, name, errorMessage, ...props }, ref) => {
    const { t } = useTranslation();

    const hasError =
      typeof value === "string" &&
      value.length > 0 &&
      !isValidSaudiPhoneNumber(value);

    return (
      <div style={{ position: "relative" }}>
        <div className={styles["container"]}>
          <div className={styles["country_selector"]}>
            <img
              className={styles["country_selector_flag"]}
              src={PhonenumberFields["SA"]?.flag}
              alt={PhonenumberFields["SA"]?.name}
            />
            <img
              className={styles["country_selector_pointer"]}
              src={"assets/images/svg/arrow_outline.svg"}
              alt={"arrow"}
            />
          </div>

          <div
            className={classNames(
              styles["phone_input"],
              hasError && styles["error_bg"]
            )}>
            <p className={styles["phone_input_prefix"]}>
              {PhonenumberFields["SA"]?.prefix}
            </p>

            <input
              ref={ref}
              name={name}
              className={styles["phone_input_field"]}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              onKeyPress={(event) => {
                if (
                  event.key === " " ||
                  event.key === "e" ||
                  event.key === "+" ||
                  event.key === "-" ||
                  event.key === "." ||
                  !validateNumber(event.key)
                ) {
                  event.preventDefault();
                }
              }}
              inputMode="numeric"
              type="tel"
              placeholder={t("lbl_enter_phone_number_hint")}
              {...props}
            />
          </div>
        </div>
        {errorMessage && (
          <div className={styles["error_container"]}>
            <p dir={"rtl"} className={styles["error_text"]}>
              {errorMessage}
            </p>
          </div>
        )}
      </div>
    );
  }
);

PhoneInput.displayName = "PhoneInput";

export default React.memo(PhoneInput);
